import { useSelector, useEffect } from 'hooks'

const useCookies = () => {
  const translations = useSelector(s => s.translations)

  useEffect(() => {
    if (/__accept_cookie/.test(document.cookie) || document.getElementById('cookie-popup')) {
      return
    }
    const popup = Object.assign(document.createElement('div'), {
      id: 'cookie-popup',
      innerHTML: /*html*/ `
        <link rel="stylesheet" href="/theme/cookie.css"/>
        <img src="/images/cookie.svg"/>
        <p>${translations['messages/weUseCookies']}</p>
        <div class="accept">${translations['actions/accept']}</div>
      `,
    })
    popup.style.visibility = 'hidden'

    popup.querySelector('.accept').onclick = () => {
      const date = new Date()
      date.setDate(date.getDate() + 365 * 100)

      document.cookie = `__accept_cookie=yes; expires=${date.toUTCString()}; path=/`
      popup.className = ''
    }

    popup.querySelector('link').onload = () =>
      setTimeout(() => {
        popup.style.visibility = ''
        popup.className = 'active'
      }, 200) // animations are too distracting otherwise

    document.body.appendChild(popup)
  }, [])
}

export default useCookies
